/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Ondulatoria() {
  return (
    <PaginasEspecificas posicao="8" endereco="/fisica" materia="Física" />
  );
}

export default Ondulatoria;
